import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppInitializerService } from '@app/app-initializer.service';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { DatePickerModel } from '@app/components/controls/utilities/models/date-picker-model';
import { FileUploadModel } from '@app/components/controls/utilities/models/file-upload-model';
import { OwlDatePickerModel } from '@app/components/controls/utilities/models/owl-date-picker-model';
import { RadioModel } from '@app/components/controls/utilities/models/radio-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { PlaylistCard } from '@app/components/widget/playlist-card/playlist-card.component';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';
import { BaseService } from '@app/system/services/base.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { ApiService as ChannelsApiService } from '@app/modules/channels/utilitites/services/api.service';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { AdvancedSearchModel } from '@app/components/controls/utilities/models/advanced-search-model';
import { ApiService as RegistrationApiService } from '@app/modules/registration-workflow/utilities/services/api.service';

@Component({
	selector: 'app-internal-event-forms',
	templateUrl: './internal-event-forms.component.html',
	styleUrls: ['./internal-event-forms.component.scss']
})
export class InternalEventFormsComponent implements OnInit {

	action: 'addEvent' | 'editEvent' | 'moderate';
	formFields: any = [];
	registrationFormFields: any = [];
	skillFormFields: any = [];
	config = { fxFlex: 100 };
	submitDisable = true;
	popupRef;
	info = '';
	title = '';
	loader = false;
	formObjectData = {
		form: null,
		fields: []
	};
	clearTimeout: any;
	currentUser: any;
	record: any;
	selectedResources = [];
	linkedResourceField = [];
	visibilityField = [];
	search: AdvancedSearchModel;

	constructor(
		public locale: LocaleService,
		private apiService: ApiService,
		private baseService: BaseService,
		public gfService: GlobalFunctionService,
		private appInit: AppInitializerService,
		private registrationApiService: RegistrationApiService,
		private globalApiService: GlobalApiService,
		private resourceApiService: ResourceApiService,
		private channelsApiService: ChannelsApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.baseService.formView = true;
		if (this.action === 'addEvent' || this.action === 'editEvent') {
			if (this.action === 'addEvent') {
				this.title = this.locale.translate('create_internal_event');
			} else {
				this.title = this.locale.translate('update_internal_event');
			}
			this.popupRef.componentInstance.popupLoader = true;
			const title: TextBoxModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('type_title')
			};
			const description: TextAreaModel = {
				fieldColumn: 'description',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('desc'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('desc')
			};
			const date: OwlDatePickerModel = {
				fieldColumn: 'date',
				additionalMetaData: {
					// maxDate: 0,
					showLabel: true,
					selectMode: 'range',
					pickerType: 'calendar',
				},
				fieldType: 'owlDate',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('date'),
				fieldOrder: 4,
				fieldPlaceholder: this.locale.translate('date')
			};
			const time: OwlDatePickerModel = {
				fieldColumn: 'time',
				additionalMetaData: {
					// maxDate: 0,
					showLabel: true,
					selectMode: 'single',
					pickerType: 'timer',
				},
				fieldType: 'owlDate',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('time'),
				fieldOrder: 4,
				fieldPlaceholder: this.locale.translate('time')
			};
			const venue: TextBoxModel = {
				fieldColumn: 'venue',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('venue'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('venue')
			};
			const meetingLink: TextBoxModel = {
				fieldColumn: 'meetingLink',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: '^(https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\s]{2,}|www\\.[a-zA-Z0-9]+\.[^\\s]{2,})$',
				fieldCaption: this.locale.translate('meeting_link'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: this.locale.translate('enter_valid_url'),
				fieldPlaceholder: this.locale.translate('meeting_link')
			};
			const thumbnail: FileUploadModel = {
				fieldCaption: this.locale.translate('cover_image'),
				fieldColumn: 'thumbnail',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 3,
				fieldType: 'fileUpload',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('drop_click_image_upload'),
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					showLabel: true,
					fileSize: '10MB',
					supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
					drag: true
				},
				isReadonly: false,
				value: null
			};
			const registration: RadioModel = {
				fieldColumn: 'registrationType',
				additionalMetaData: {},
				fieldType: 'radio',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				options: this.baseService.getRegistrationType,
				fieldCaption: '',
				fieldHelpText: null,
				fieldHelpTextLong: null
			};
			const registerBy: DatePickerModel = {
				fieldColumn: 'registerBy',
				additionalMetaData: {
					// maxDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('register_by_date'),
				fieldPlaceholder: this.locale.translate('register_by_date'),
				value: null
			};
			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('skill_caption'),
				fieldOrder: 1,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('skills'),
				type: 'weightage'
			};
			const linkedResource: AutoCompleteModel = {
				fieldColumn: 'linkedResource',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('type_title'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('type_title')
			};
			const channel: AutoCompleteModel = {
				fieldColumn: 'channel',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('channels'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_channels')
			};
			if (this.currentUser.weightageData) {
				skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
			}
			if (this.action === 'editEvent') {
				this.popupRef.componentInstance.popupLoader = true;
				const headers: any = {
					lanCode: sessionStorage.getItem('locale') || 'en'
				};
				this.resourceApiService.detail(this.record.resourceID, headers).subscribe(
					(response) => {
						if (response) {
							title.value = response.title;
							description.value = response.description;
							if (response.resource) {
								thumbnail.value = {
									name: response.resource.thumbnail
								};
								thumbnail.additionalMetaData.thumbnail = response.resource.thumbnail;
							}
							if (response.linkedResource) {
								this.addSelectedResource(response.linkedResource);
							}
							if (response.infoFields) {
								if (response.infoFields.startDate && response.infoFields.endDate) {
									date.value = [new Date(response.infoFields.startDate), new Date(response.infoFields.endDate)];
								}
								if (response.infoFields.venue) {
									venue.value = response.infoFields.venue;
								}
								if (response.infoFields.time) {
									time.value = new Date(response.infoFields.time);
								}
								if (response.infoFields.registerBy) {
									registerBy.value = new Date(response.infoFields.registerBy);
								}
								if (response.infoFields.registrationType) {
									registration.value = response.infoFields.registrationType;
								}
								if (response.infoFields.meetingLink) {
									meetingLink.value = response.infoFields.meetingLink;
								}
							}
							if (response.skills && response.skills.length) {
								skills.selectedValue = response.skills.map(resp => {
									return {
										key: resp.skill.key,
										value: resp.skill.value,
										isDelete: false,
										isAdd: true,
										weightage: resp.skillLevel
									};
								});
								skills.value = skills.selectedValue;
							}
						}
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
					.add(() => {
						this.formFields = [
							title,
							description,
							date,
							time,
							venue,
							meetingLink,
							thumbnail
						];
						this.registrationFormFields = [
							registration,
							registerBy
						];
						this.skillFormFields = [
							skills
						];
						this.linkedResourceField = [linkedResource];
						this.popupRef.componentInstance.popupLoader = false;
						this.submitDisable = false;
					});
			} else {
				this.loadChannel(channel);
				this.formFields = [
					title,
					description,
					date,
					time,
					venue,
					meetingLink,
					thumbnail
				];
				this.registrationFormFields = [
					registration,
					registerBy
				];
				this.skillFormFields = [
					skills
				];
				this.linkedResourceField = [linkedResource];
				this.visibilityField = [channel];
				this.popupRef.componentInstance.popupLoader = false;
				this.submitDisable = false;
			}
		} else if (this.action === 'moderate') {
			this.title = this.locale.translate('moderate');
			this.popupRef.componentInstance.popupLoader = true;
			const remarks: TextAreaModel = {
				fieldColumn: 'userRemarks',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('remarks'),
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('remarks')
			};
			this.formFields = [remarks];
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		}
	}

	loadChannel(channelField) {
		channelField.options = [];
		const apiData = {};
		const headers: any = {};

		let selectedValue = [];
		if (channelField.selectedValue.length) {
			channelField.selectedValue.map(items => {
				if (items.isAdd && !items.isDelete) {
					selectedValue.push(items.key);
				}
			});
		}
		this.channelsApiService.getChannelList(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					if (selectedValue.length) {
						response.records = response.records.filter(items => {
							if (!selectedValue.includes(items.channelID)) {
								return items;
							}
						});
					}
					channelField.options = response.records.map((data) => {
						return {
							key: data.channelID,
							value: data.channelName
						};
					});
				}

			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		);
	}

	formObjectReader(record: any) {
		if (record && record.form && record.form.controls && record.form.controls.date) {
			const form: UntypedFormGroup = record.form;
			form.controls.date.valueChanges.subscribe(controlResp => {
				if (controlResp && Array.isArray(controlResp) && controlResp.length) {
					if (this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.registerBy) {
						this.formObjectData.form.controls.registerBy.patchValue(controlResp[1], { emitEvent: false });
					}
				} else {
					if (this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.registerBy) {
						this.formObjectData.form.controls.registerBy.patchValue(null, { emitEvent: false });
					}
				}
			});
		}
		if (record && record.form && record.form.controls && record.form.controls.linkedResource) {
			let subscribe;
			const linkedResourceField = record.fields.find((items) => items.fieldColumn === 'linkedResource');
			record.form.controls.linkedResource.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					if (controlResp && typeof controlResp === 'object') {
						if (controlResp.isAdd) {
							this.addSelectedResource([controlResp.key]);
						}
						linkedResourceField.selectedValue = [];
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							let selectedValue = [];
							this.selectedResources.map(items => {
								selectedValue.push(items.resourceID);
							});
							const apiData = {
								searchString: controlResp
							};
							const header: any = {
								lanCode: sessionStorage.getItem('locale') || 'en'
							};
							subscribe = this.globalApiService.searchByResource(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										response.records = response.records.filter(items => {
											if (!selectedValue.includes(items.resourceID)) {
												return items;
											}
										});
										linkedResourceField.options = [];
										for (const record of response.records) {
											linkedResourceField.options.push(
												{
													key: record,
													value: record.title
												}
											);
										}
									} else {
										linkedResourceField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									linkedResourceField.options = [];
								}
							);
						} else {
							linkedResourceField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (record && record.form && record.form.controls && record.form.controls.channel) {
			let subscribe;
			const channelField = record.fields.find((items) => items.fieldColumn === 'channel');
			record.form.controls.channel.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (channelField.selectedValue.length) {
								channelField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.channelsApiService.getChannelList(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.channelID)) {
													return items;
												}
											});
										}
										channelField.options = response.records.map((data) => {
											return {
												key: data.channelID,
												value: data.channelName
											};
										});
									} else {
										channelField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									channelField.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								channelField.options = [];
							} else {
								this.loadChannel(channelField);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	addSelectedResource(resources) {
		for (const resource of resources) {
			let finalData: any = {};
			if (resource.resourceTypeID) {
				resource.resourceType = this.baseService.referenceType('resourceType', resource.resourceTypeID);
				if (resource.resourceType.key === 'answer') {
					const cardData: QuestionCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: '',
						removable: true
					};

					finalData = cardData;
				} else if (resource.resourceType.key === 'playlist') {
					const cardData: PlaylistCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						// type: resource.resourceType.caption,
						thumbnail: '',
						removable: true
						// playlistItemCount: data.count
					};

					finalData = cardData;
				} else if (['internalEvent', 'externalEvent'].includes(resource.resourceType.key)) {
					const cardData: EventCard = {
						thumbnail: '',
						title: resource.title,
						eventType: (resource.resourceType && resource.resourceType.key) ? resource.resourceType.key : null,
						removable: true
					};

					finalData = cardData;
				} else {
					const cardData: ContentImageCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(resource.createdAt, 'MMM d, y'),
						thumbnail: '',
						removable: true
					};
					finalData = cardData;

				}

				finalData.type = resource.resourceType.caption;
			}

			if (resource.resource.hasOwnProperty('duration')) {
				finalData.duration = resource.resource.duration;
			}

			// if (resource.description) {
			// 	cardData.description = resource.description;
			// 	}
			if (resource.resource && resource.resource.thumbnail && resource.resourceType && resource.resourceType.key !== 'answer') {
				finalData.thumbnail = resource.resource.thumbnail;
			}
			if (resource.resourceFormat) {
				resource.resourceFormat = this.baseService.referenceType('resourceFormat', resource.resourceFormat);
				finalData.format = resource.resourceFormat.key;
				if (finalData.thumbnail === '') {
					finalData.thumbnail = resource.resourceFormat.image;
				}
			}

			const extraData = {
				resourceID: resource.resourceID,
				createdBy: resource.createdBy
			};
			this.selectedResources.push(this.gfService.JSONMerge(finalData, extraData));
		}
		if (this.selectedResources && this.selectedResources.length >= 10 && this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.linkedResource) {
			this.formObjectData.form.controls.linkedResource.disable({ emitEvent: false });
		}
	}

	removeResource(index) {
		if (navigator.onLine) {
			this.selectedResources.splice(index, 1);
			if (this.selectedResources && this.selectedResources.length < 10 && this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.linkedResource && this.formObjectData.form.controls.linkedResource.disabled) {
				this.formObjectData.form.controls.linkedResource.enable({ emitEvent: false });
			}
		}
	}

	registrationFormObjectReader(record: any) {
	}

	skillFormObjectReader(record: any) {
		if (record && record.form && record.form.controls && record.form.controls.skills) {
			let subscribe;
			const skills = this.skillFormFields.find((items) => items.fieldColumn === 'skills');
			const form: UntypedFormGroup = record.form;
			form.controls.skills.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (skills.selectedValue.length) {
								skills.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										skills.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										skills.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									skills.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								skills.options = [];
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	submit() {
		if (navigator.onLine) {
			if (this.action === 'addEvent' || this.action === 'editEvent') {
				this.addEvent();
			} else if (this.action === 'moderate') {
				this.moderate();
			}
		}
	}

	moderate() {
		if (this.formObjectData && this.formObjectData.form) {
			this.gfService.alertClear('manageForm');
			this.submitDisable = true;
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				let msg;
				if (this.record.action === 'approve') {
					apiData.status = 1;
					msg = this.locale.translate('approved');
				} else if (this.record.action === 'decline') {
					apiData.status = 2;
					msg = this.locale.translate('declined');
				}
				const headers: any = {};
				this.registrationApiService.updateRequest(apiData, this.record.requestID, headers)
					.subscribe(
						(response) => {
							if (response) {
								this.popupRef.close(this.gfService.JSONMerge(apiData, response.recordID));
								this.gfService.openSnackBar('SUCCESS', {
									message: msg,
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === "DUPLICATE") {
								this.gfService.openSnackBar('ERROR', {
									message: this.locale.translate('you_have_already_registered'),
									icon: 'error',
									position: 'before'
								});
							} else {
								this.gfService.errorHandler(error, {
									alert: {
										id: 'manageForm'
									},
									form: this.formObjectData.form
								});
							}
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	addEvent() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('eventAlert');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;

				const headers: any = {};
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);

				const skills = [];
				for (const skill of formValue.skills) {
					if (!skill.value && skill.isAdd && !skill.isDelete) {
						skills.push({
							skill: skill.key,
							skillLevel: skill.progress
						});
					} else if (skill.value) {
						if (skill.value.isAdd && !skill.value.isDelete) {
							const skillData: any = { skillName: skill.value.value };
							if (skill.value.progress) {
								skillData.skillLevel = skill.value.progress;
							}
							skills.push(skillData);
						}
					}
				}

				formValue.skills = skills;

				if (!formValue.thumbnail || (formValue.thumbnail && !(formValue.thumbnail instanceof File))) {
					delete formValue.thumbnail;
				}
				const apiData: any = {
					title: formValue.title,
					description: formValue.description,
					skills,
					resourceTypeID: this.baseService.resourceType.find(items => items.key === 'internalEvent').value,
					languageCode: 'en',
					infoFields: {
						startDate: Date.parse(formValue.date[0]),
						endDate: Date.parse(formValue.date[1]),
						venue: formValue.venue,
						registrationType: formValue.registrationType,
						registerBy: formValue.registerBy,
						meetingLink: formValue.meetingLink
					},
					resourceFormat: null,
					// expiryDate: Date.parse(formValue.date[1])
				};
				const visibility: any = {};
				if (formValue.channel) {
					const channelsID = [];
					for (const channel of formValue.channel) {
						if (channel.isAdd && !channel.isDelete) {
							channelsID.push(channel.key);
						}
					}
					if (channelsID.length > 0) {
						visibility.channel = channelsID;
					}
				}
				if (Object.keys(visibility).length > 0) {
					apiData.settings = {
						visibility
					};
				}
				if (this.selectedResources.length > 0) {
					const linkedResources = [];
					for (const resource of this.selectedResources) {
						linkedResources.push(resource.resourceID);
					}
					if (linkedResources.length > 0) {
						apiData.linkedResource = linkedResources;
					}
				} else {
					apiData.linkedResource = [];
				}
				if (formValue.date && formValue.date.length) {
					const startDate: any = new Date(Date.parse(formValue.date[0]));
					const time: Date = formValue.time;
					startDate.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
					apiData.infoFields.time = Date.parse(startDate);
				}
				if (formValue.thumbnail) {
					apiData.thumbnail = formValue.thumbnail;
				}
				let formData;
				formData = this.gfService.convertToFormData(apiData);
				let method = this.apiService.saveInternalEvent(formData, headers);
				let msg = 'event_created';
				if (this.action === 'editEvent') {
					msg = 'event_updated';
					method = this.apiService.updateInternalEvent(formData, this.record.resourceID, headers);
				}
				method.subscribe(
					async (response) => {
						if (response) {
							this.popupRef.close(this.gfService.JSONMerge(apiData, { updated: true }));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate(msg),
								icon: 'check_circle_outline',
								position: 'before'
							});
						}
					},
					(error) => {
						this.gfService.alertHandler(error, 'eventAlert', 'ERROR');
						this.gfService.formErrorHandler(error, this.formObjectData.form);
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}
}
